import { render, staticRenderFns } from "./ClassMoment.vue?vue&type=template&id=02108bdb&"
import script from "./ClassMoment.vue?vue&type=script&lang=js&"
export * from "./ClassMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports